<template>

<div>
  <PageTitle :route="$route" />

  <PageRowWrapper>
    <OsSWForm />
  </PageRowWrapper>
</div>

</template>

<script>
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import OsSWForm from '@/components/os-sw/OsSWForm'

export default {
  name: 'OsSWAdd',
  components: {
    PageTitle,
    PageRowWrapper,
    OsSWForm
  }
}
</script>